import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MantineProvider, Container, Title, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { FamilySearch } from "./components/FamilySearch";
import { FamilyDetails } from "./components/FamilyDetails";
import { FamilyByLink } from "./components/FamilyByLink";
import { AdminDashboard } from "./components/AdminDashboard";
import "@mantine/core/styles.css";
import "./index.css";

function HomePage() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [selectedFamilyId, setSelectedFamilyId] = useState<number | null>(null);
  const [isSearchActive, setIsSearchActive] = useState(false);

  const handleFamilySelect = (familyId: number) => {
    setSelectedFamilyId(familyId);
  };

  const handleBack = () => {
    setSelectedFamilyId(null);
  };

  return (
    <Container size="md">
      {!(isMobile && isSearchActive) && (
        <div style={{ 
          textAlign: "center", 
          marginBottom: "3rem",
          padding: "2rem 0",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "12px",
          transition: "all 0.3s ease"
        }}>
          <Title order={1} style={{ fontFamily: 'Breathe Fire, cursive' }}>
            Marine & Arthur
          </Title>
          <Title order={2} style={{ fontFamily: 'Breathe Fire, cursive' }}>
            2026
          </Title>
          <Text c="dimmed" size="md" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
            Une date pour vous regrouper tous
            <img src="/rings-wedding.svg" alt="rings" style={{ width: '20px', height: '20px', display: 'inline-block' }} />
            ...
          </Text>
        </div>
      )}

      {selectedFamilyId === null ? (
        <FamilySearch 
          onFamilySelect={handleFamilySelect}
          onSearchActive={setIsSearchActive}
        />
      ) : (
        <FamilyDetails familyId={selectedFamilyId} onBack={handleBack} />
      )}
    </Container>
  );
}

function AdminPage() {
  return (
    <Container size="xl">
      <div style={{ 
        textAlign: "center", 
        marginBottom: "3rem",
        padding: "2rem 0"
      }}>
        <Title order={1} style={{ marginBottom: "0.5rem" }}>
          Admin Dashboard
        </Title>
        <Text c="dimmed" size="lg">
          Manage guest list and view RSVPs
        </Text>
      </div>

      <AdminDashboard />
    </Container>
  );
}

function FamilyLinkPage() {
  return (
    <Container size="md">
      <div style={{ 
        textAlign: "center", 
        marginBottom: "3rem",
        padding: "2rem 0"
      }}>
        <Title order={1} style={{ marginBottom: "0.5rem" }}>
          Vos invitations
        </Title>
        <Text c="dimmed" size="lg">
          Serez-vous disponible pour cette journée spéciale ?
        </Text>
      </div>

      <FamilyByLink />
    </Container>
  );
}

export function App() {
  return (
    <MantineProvider>
      <BrowserRouter>
        <div style={{ 
          minHeight: "100vh", 
          backgroundColor: "#f8f9fa",
          backgroundImage: "url('./map.tiff')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          backgroundRepeat: "no-repeat",
          padding: "2rem 0"
        }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/family/:link" element={<FamilyLinkPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
